import React from "react";
import { Route } from "react-router-dom";

const Resident = React.lazy(() => import("../Containers/Resident"));
const ResidentEditTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentEditTabs"),
);
const PreAssessmentAdd = React.lazy(
  () => import("../Containers/Resident/ResidentPreAssessment/PreAssessmentAdd"),
);
const ResidentSettingsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentSettingsTabs"),
);
const ResidentAdd = React.lazy(
  () => import("../Containers/Resident/ResidentAdd"),
);
const ResidentAssessmentsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentAssessmentsTabs"),
);
const ResidentCarePlanTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentCarePlanTabs"),
);
const ResidentComplianceTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentComplianceTabs"),
);
const ResidentInsightsToolsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentInsightsToolsTabs"),
);
const ResidentLocationRulesTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentLocationRulesTabs"),
);
const ResidentPreAssessment = React.lazy(
  () => import("../Containers/Resident/ResidentPreAssessment"),
);
const paths = [
  {
    path: "/d/resident",
    component: () => <Resident />,
  },
  {
    path: "/d/resident/edit/:id/critical-information",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/profile",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/medications",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/assessments",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/timeline",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/care-plan",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/warnings",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/appointments",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/upload-documents",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/basic-information",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/observations",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/summaries",
    component: () => <ResidentEditTabs />,
  },
];

const ResidentRoutes = ({ itemValidator }) => {
  return (
    <>
      {paths.map((path) => (
        <Route
          exact
          key={path.path}
          path={path.path}
          // component={path.component}
          render={() => itemValidator(path.component(), `RESIDENT`, `DISPLAY`)}
        />
      ))}
      <Route
        exact
        path="/d/resident/add"
        render={() => itemValidator(<ResidentAdd />, `RESIDENT`, `DISPLAY`)}
      />
      <Route
        exact
        path="/d/resident/pre-assessment-list"
        render={() =>
          itemValidator(<ResidentPreAssessment />, `RESIDENT`, `DISPLAY`)
        }
      />

      <Route
        exact
        path="/d/r/settings/medical-condition"
        render={() =>
          itemValidator(<ResidentSettingsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/pre-assessment/add"
        render={() => itemValidator(<PreAssessmentAdd />, `RESIDENT`, `WRITE`)}
      />
      <Route
        exact
        path="/d/resident/pre-assessment/edit/:id"
        render={() =>
          itemValidator(
            <PreAssessmentAdd isEditing={true} />,
            `RESIDENT`,
            `WRITE`,
          )
        }
      />
      {/* Generic Routes */}
      <Route
        exact
        path="/d/r/settings/generic"
        render={() =>
          itemValidator(<ResidentSettingsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />

      {/* Assessments Routes */}
      <Route
        exact
        path="/d/r/settings/assessments"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/needs"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/risk"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/medical-condition"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/capacity"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      {/* <Route
        exact
        path="/d/resident/settings/assessments/dols"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      /> */}
      {/* Care Plan Routes */}
      <Route
        exact
        path="/d/r/settings/care-plan"
        render={() =>
          itemValidator(<ResidentCarePlanTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      {/* Compliance Routes */}
      <Route
        exact
        path="/d/r/settings/compliance"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/safeguarding"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/consent"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/governance"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      {/* Insights & Tools Routes */}
      <Route
        exact
        path="/d/r/settings/insights"
        render={() =>
          itemValidator(<ResidentInsightsToolsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/insights/charts"
        render={() =>
          itemValidator(<ResidentInsightsToolsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      {/* Location Rules Route */}
      <Route
        exact
        path="/d/r/settings/location-rules"
        render={() =>
          itemValidator(<ResidentLocationRulesTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
    </>
  );
};

export default ResidentRoutes;
